import service from '@/utils/request';
// 登录
export function login(username, password) {
    return service.postRequestJson('/user/login', {
        loginName: username,
        password: password
    })
}
// 获取用户信息
export function getInfo() {
    return service.getRequestJson('/user/info');
}
// 登出
export function logout() {
    return service.postRequestJson('/user/logout');
}

// 获取经销商简称
export function getBriefName(loginName) {
    return service.getRequestJson('/user/getBriefName', {
        params:loginName
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js